import {
  ITextLinkMvp as IContentfulTextLink,
  CONTENT_TYPE,
} from 'marketing-site/@types/generated/contentful'
import { IProps as ITextLink } from 'marketing-site/src/mvp/library/elements/TextLink'
import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'
import kebabCase from 'lodash.kebabcase'

export function transformTextLink({ fields }: IContentfulTextLink): ITextLink {
  const modalContentTypeId = fields.modalContent?.sys.contentType?.sys.id as CONTENT_TYPE
  const modalEntry = fields.modalContent
  return {
    ...fields,
    renderModalContent:
      fields.modalContent && (() => renderTransformedComponent(modalContentTypeId, modalEntry!)),
    isWistiaVideo: modalContentTypeId === 'wistiaVideo',
    modalSize: fields.modalSize && (kebabCase(fields.modalSize) as ITextLink['modalSize']),
  }
}
